'use strict';

module Patersons {

  export interface ContactInfoScope extends ng.IScope {
    phoneNumberForm: ng.IFormController;
    accountEmailAddressForm: ng.IFormController;
    contractEmailAddressForm: ng.IFormController;
    postalAddressForm: ng.IFormController;
    registrationAddressForm: ng.IFormController;
    residentialAddressForm: ng.IFormController;
    parentController: AbstractController;
    accounts: Array<Account>;
    selectedAccount: Account;
    events: Patersons.ContactInfoViewCtrl;
    date: Date;
    isLoading: boolean;
    url: String;
    errorHandler: any;
    isSubmitted: boolean;
    phoneNumberIsVerified: boolean;
    allApproversRegistered: boolean;
    submissionFailedVerifyPhoneNumber: boolean;
    submissionFailedNotAllApproversRegistered: boolean;
    hasApprovers: boolean;
    isSensitive: boolean;
    scrollDuration: number;
    emailTags: Array<any>;
    contractEmailTags: Array<any>;
    sensitiveEmailAddressesDirty: boolean;
    userCompany: UserCompany;
    applyToAll: boolean;
  }

  const AccountEmail = "AccountEmail";
  const ContractNoteEmail = "ContractNoteEmail";

  export class ContactInfoViewCtrl extends AccountBaseCtrl {
    scope: Patersons.ContactInfoScope;
    myDetailsService: Patersons.MyDetailsService;
    portfolioService: Patersons.PortfolioService;
    tokenService: Patersons.TokenService;
    identityService: Patersons.IdentityService;
    changeRequestService: Patersons.ChangeRequestService;
    modal: any;
    document: any;
    nextEmailId: number;

    static $inject = ['$scope', '$uibModal', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', '$document', 'myDetailsService', 'portfolioService', 'tokenService', 'changeRequestService', 'navigationService','identityService', 'userCompanyService'];

    constructor($scope, $uibModal, $log, $location, $window, $state, $stateParams, $http, $rootScope, $document, myDetailsService, portfolioService, tokenService, changeRequestService, navigationService, identityService, userCompanyService) {
      super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
      this.scope = $scope;
      this.myDetailsService = myDetailsService;
      this.portfolioService = portfolioService;
      this.tokenService = tokenService;
      this.identityService = identityService;
      this.changeRequestService = changeRequestService;
      this.scope.parentController = this;
      this.scope.events = this;
      this.scope.isSubmitted = false;
      this.scope.submissionFailedVerifyPhoneNumber = false;
      this.scope.submissionFailedNotAllApproversRegistered = false;
      this.scope.phoneNumberIsVerified = false;
      this.scope.allApproversRegistered = false;
      this.scope.hasApprovers = false;
      var accountId = $stateParams.accountId;
      this.modal = $uibModal;

      this.scope.emailTags = [];
      this.scope.contractEmailTags = [];

      this.document = $document;
      this.scope.scrollDuration = 700;
      this.load();
      userCompanyService.getUserCompany().then((company) => {
        this.scope.userCompany = company;
      })
    }

    setSelectedAccount(accountId: string) {
      this.scope.selectedAccount = this.scope.accounts.filter(a => a.accountId == accountId)[0];

      if (this.setSelectedAccount == null) {
        return;
      }

      if (this.scope.selectedAccount.email) {
        this.scope.emailTags = this.scope.selectedAccount.email.split(";").join(",").split(",").map((e) => { return { text: e.toLowerCase() }; });
      }
      else {
        this.scope.emailTags = [];
      }
      if (this.scope.selectedAccount.emailContractNotes) {
        this.scope.contractEmailTags = this.scope.selectedAccount.emailContractNotes.split(";").join(",").split(",").map((e) => { return { text: e.toLowerCase() }; });
      }
      else {
        this.scope.contractEmailTags = [];
      }
      this.scope.sensitiveEmailAddressesDirty = false;
      this.scope.isSubmitted = false;
      this.scope.submissionFailedVerifyPhoneNumber = false;
      this.scope.submissionFailedNotAllApproversRegistered = false;

      this.checkAllApproversRegistered();
      this.checkHasApprovers();
    };

    checkAllApproversRegistered() {
      if (!this.scope.selectedAccount) {
        return;
      }

      this.changeRequestService.areAllAccountApproversRegistered(this.scope.selectedAccount.accountId)
        .then((result: boolean) => {
          this.scope.allApproversRegistered = result;
        });
    }

    checkHasApprovers() {
      if (!this.scope.selectedAccount) {
        return;
      }

      this.changeRequestService.getAccountApproversCount(this.scope.selectedAccount.accountId)
        .then((result: number) => {
          this.scope.hasApprovers = result > 0;
        }, (reason) => {
            this.scope.errorHandler = reason.data;
            var scrollPlaceholder = angular.element(document.getElementById('scrollPlaceholder'));
            this.document.scrollToElement(scrollPlaceholder, 0, this.scope.scrollDuration);
            this.scope.isLoading = false;
          });
    }

    load() {
      this.identityService.getIsPhoneNumberVerifyed().
      then((phone_number_verified: boolean) => {
        this.scope.phoneNumberIsVerified = phone_number_verified;
        var promise = this.portfolioService.getCombinedPortfolioData();
        promise.then((result: Array<Account>) => {
          this.scope.accounts = result;
          if (this.scope.accounts != undefined && this.scope.accounts.length > 0) {
            this.setSelectedAccount(this.scope.accounts[0].accountId);
          }
        }, (reason) => {
            this.scope.errorHandler = reason.data;
            var scrollPlaceholder = angular.element(document.getElementById('scrollPlaceholder'));
            this.document.scrollToElement(scrollPlaceholder, 0, this.scope.scrollDuration);
            this.scope.isLoading = false;
          });
      });

      /*if (this.tokenService.tokenManager.profile.phone_number_verified === 'true') {
        this.scope.phoneNumberIsVerified = true;
      }

      var promise = this.portfolioService.getCombinedPortfolioData();
      promise.then((result: Array<Account>) => {
        this.scope.accounts = result;
        if (this.scope.accounts != undefined && this.scope.accounts.length > 0) {

          this.setSelectedAccount(this.scope.accounts[0].accountId);
        }
      }, (reason) => {
          this.scope.errorHandler = reason.data;
          var scrollPlaceholder = angular.element(document.getElementById('scrollPlaceholder'));
          this.document.scrollToElement(scrollPlaceholder, 0, this.scope.scrollDuration);
          this.scope.isLoading = false;
        });*/
    }

    canSubmitChangeRequest() {
      this.hideAllNotifications();

      if (!this.scope.phoneNumberIsVerified) {
        this.scope.submissionFailedVerifyPhoneNumber = true;
      }

      if (!this.scope.allApproversRegistered) {
        this.scope.submissionFailedNotAllApproversRegistered = true;
      }

      if (this.scope.submissionFailedVerifyPhoneNumber || this.scope.submissionFailedNotAllApproversRegistered) {
        return false;
      }

      return true;
    }
    setAllAddressFields(address: Address) {
      if(!this.scope.selectedAccount.isAuthorisedAgentAccount){
        this.scope.selectedAccount.accountAddresses.postalAddress = Object.assign({}, address, {type: "Postal"});
        this.scope.selectedAccount.accountAddresses.residentialOrBusinessAddress = Object.assign({}, address, {type: "ResidentialOrBusiness"});
      }
      if(!(this.scope.selectedAccount.isAuthorisedAgentAccount || this.scope.selectedAccount.accountType == 'Accolade')){
        this.scope.selectedAccount.accountAddresses.registrationAddress = Object.assign({}, address, {type: "Registration"});
      }

    }

    applyToAll(addressForm, invalid){
      if(!invalid){
        if(confirm("This will apply your residential address to all sections of this form and submit your changes to us for processing")){
          this.setAllAddressFields(addressForm)
          return Promise.resolve()
            .then(() => {
              return this.saveRegistrationAddress();
            })
            .then(() => {
              return this.savePostalAddress();
            })
            .then(() => {
              return this.saveResidentialAddress();
            })
        }
      }
    }

    savePostalAddress() {
      return new Promise((resolve, reject) => {
        if(this.scope.selectedAccount.isAuthorisedAgentAccount){
          return resolve()
        }
        this.scope.$broadcast('show-errors-check-validity');
        this.scope.isSensitive = false;
  
        if (this.scope.postalAddressForm.$invalid) {
          return resolve()
        }
  
        var promises = [];
        promises.push(
          this.portfolioService.updatePostalAddressDetails(
            this.scope.selectedAccount.accountId,
            this.scope.selectedAccount.accountAddresses.postalAddress));
  
        this.executePromises(promises).then(() => {
            return resolve()
          }, (reason) => {
            return reject()
          });
      })
    }

    saveResidentialAddress() {
      return new Promise((resolve, reject) => {
        if(this.scope.selectedAccount.isAuthorisedAgentAccount){
          return resolve()
        }
        this.scope.$broadcast('show-errors-check-validity');
        this.scope.isSensitive = false;
  
        if (this.scope.residentialAddressForm.$invalid) {
          return resolve()
        }
  
        var promises = [];
        promises.push(
          this.portfolioService.updateResidentialAddressDetails(
            this.scope.selectedAccount.accountId,
            this.scope.selectedAccount.accountAddresses.residentialOrBusinessAddress));
  
        this.executePromises(promises).then(() => {
            return resolve()
          }, (reason) => {
            return reject()
          });
      });
    }

    saveRegistrationAddress() {
      return new Promise((resolve, reject) => {
        if(this.scope.selectedAccount.isAuthorisedAgentAccount || this.scope.selectedAccount.accountType == 'Accolade'){
          return resolve();
        }
        this.scope.$broadcast('show-errors-check-validity');
        this.scope.isSensitive = true;
  
        if (this.scope.registrationAddressForm.$invalid) {
          return resolve();
        }
  
        if (!this.canSubmitChangeRequest()) {
          var scrollPlaceholder = angular.element(document.getElementById('scrollPlaceholder'));
          this.document.scrollToElement(scrollPlaceholder, 0, this.scope.scrollDuration);
          return reject();
        }
  
        var modalPopup = this.modal.open({
          templateUrl: 'assets/templates/common/twoFactorAuthentication.html',
          controller: SensitiveAddressChangeRequestCtrl,
          keyboard: false,
          backdrop: 'static',
          resolve: {
            account: this.scope.selectedAccount,
            address: this.scope.selectedAccount.accountAddresses.registrationAddress
          }
        });
  
        modalPopup.result
          .then((result) => {
            if (result === true) {
              var scrollPlaceholder = angular.element(document.getElementById('scrollPlaceholder'));
              this.document.scrollToElement(scrollPlaceholder, 0, this.scope.scrollDuration);
              this.scope.isSubmitted = true;
              return resolve();
            }
            else {
              this.scope.errorHandler.Message = 'Error saving registration address details';
              return reject()
            }
          }, (reason) => {
              this.scope.errorHandler = reason.data;
              var scrollPlaceholder = angular.element(document.getElementById('scrollPlaceholder'));
              this.document.scrollToElement(scrollPlaceholder, 0, this.scope.scrollDuration);
              this.scope.isLoading = false;
              return reject()
            });
      });
    }

    // non sensitive
    saveAccountEmailAddressForm() {
      this.scope.$broadcast('show-errors-check-validity');
      this.scope.isSensitive = true;

      if (this.scope.accountEmailAddressForm.$invalid) {
        return;
      }

      /*if (!this.canSubmitChangeRequest()) {
        var scrollPlaceholder = angular.element(document.getElementById('scrollPlaceholder'));
        this.document.scrollToElement(scrollPlaceholder, 0, this.scope.scrollDuration);
        return;
      }*/

      /*var sensitiveEmailAddresses: Array<EmailAddress> = [
        new EmailAddress(0, ContractNoteEmail, this.scope.contractEmailTags.map((tag) => { return tag.text }).join(','))
      ];*/

      var nonSensitiveEmailAddresses: Array<EmailAddress> = [
        new EmailAddress(1, AccountEmail, this.scope.emailTags.map((tag) => { return tag.text }).join(','))
      ];

      // if the list of contract notes email addresses has changed or one of the email addresses has been deleted
      /*if (sensitiveEmailAddresses.length > 0 && this.scope.sensitiveEmailAddressesDirty) {
        var modalPopup = this.modal.open({
          templateUrl: 'assets/templates/common/twoFactorAuthentication.html',
          controller: SensitiveEmailAddressChangeRequestCtrl,
          keyboard: false,
          backdrop: 'static',
          resolve: {
            account: this.scope.selectedAccount,
            emailAddresses: function() { return sensitiveEmailAddresses }
          }
        });

        modalPopup.result
          .then((result) => {
            if (result === true) {
              var promises = [];

              for (var i = 0; i < nonSensitiveEmailAddresses.length; i++) {
                promises.push(this.portfolioService.updateEmailAddress(this.scope.selectedAccount.accountId, nonSensitiveEmailAddresses[i]));
              }

              this.executePromises(promises);

              this.scope.isSubmitted = true;
              this.scope.sensitiveEmailAddressesDirty = false;
            }
            else {
              this.scope.errorHandler.Message = 'Error saving email address details';
            }
          });
      }
      else {*/
        var promises = [];
        for (var i = 0; i < nonSensitiveEmailAddresses.length; i++) {
          promises.push(this.portfolioService.updateEmailAddress(this.scope.selectedAccount.accountId, nonSensitiveEmailAddresses[i]));
        }
        this.executePromises(promises);
        this.scope.isSubmitted = true;
      //}
    }

    // sensitive
    saveContractEmailAddressForm() {
      this.scope.$broadcast('show-errors-check-validity');
      this.scope.isSensitive = true;

      if (this.scope.contractEmailAddressForm.$invalid) {
        return;
      }

      if (!this.canSubmitChangeRequest()) {
        var scrollPlaceholder = angular.element(document.getElementById('scrollPlaceholder'));
        this.document.scrollToElement(scrollPlaceholder, 0, this.scope.scrollDuration);
        return;
      }

      var sensitiveEmailAddresses: Array<EmailAddress> = [
        new EmailAddress(0, ContractNoteEmail, this.scope.contractEmailTags.map((tag) => { return tag.text }).join(','))
      ];

      /*var nonSensitiveEmailAddresses: Array<EmailAddress> = [
        new EmailAddress(1, AccountEmail, this.scope.emailTags.map((tag) => { return tag.text }).join(','))
      ];*/

      // if the list of contract notes email addresses has changed or one of the email addresses has been deleted
      if (sensitiveEmailAddresses.length > 0 && this.scope.sensitiveEmailAddressesDirty) {
        var modalPopup = this.modal.open({
          templateUrl: 'assets/templates/common/twoFactorAuthentication.html',
          controller: SensitiveEmailAddressChangeRequestCtrl,
          keyboard: false,
          backdrop: 'static',
          resolve: {
            account: this.scope.selectedAccount,
            emailAddresses: function() { return sensitiveEmailAddresses }
          }
        });

        modalPopup.result
          .then((result) => {
            if (result === true) {
              /*var promises = [];

              for (var i = 0; i < nonSensitiveEmailAddresses.length; i++) {
                promises.push(this.portfolioService.updateEmailAddress(this.scope.selectedAccount.accountId, nonSensitiveEmailAddresses[i]));
              }

              this.executePromises(promises);
              */
              var scrollPlaceholder = angular.element(document.getElementById('scrollPlaceholder'));
              this.document.scrollToElement(scrollPlaceholder, 0, this.scope.scrollDuration);
              this.scope.isSubmitted = true;
              this.scope.sensitiveEmailAddressesDirty = false;
            }
            else {
              this.scope.errorHandler.Message = 'Error saving email address details';
            }
          }, (reason) => {
              this.scope.errorHandler = reason.data;
              var scrollPlaceholder = angular.element(document.getElementById('scrollPlaceholder'));
              this.document.scrollToElement(scrollPlaceholder, 0, this.scope.scrollDuration);
              this.scope.isLoading = false;
            });
      }
      /*else {
        var promises = [];
        for (var i = 0; i < nonSensitiveEmailAddresses.length; i++) {
          promises.push(this.portfolioService.updateEmailAddress(this.scope.selectedAccount.accountId, nonSensitiveEmailAddresses[i]));
        }
        this.executePromises(promises);
        this.scope.isSubmitted = true;
      }*/
    }

    savePhoneNumberForm() {
      this.scope.$broadcast('show-errors-check-validity');
      this.scope.isSensitive = false;

      if (this.scope.phoneNumberForm.$invalid) {
        return;
      }

      this.scope.isLoading = true;
      var promises = [];

      promises.push(this.portfolioService.updatePhoneNumbers(this.scope.selectedAccount.accountId, this.scope.selectedAccount));

      return this.executePromises(promises);
    }

    hideAllNotifications(){
      this.scope.isSubmitted = false;
      this.scope.submissionFailedVerifyPhoneNumber = false;
      this.scope.submissionFailedNotAllApproversRegistered = false;
    }

    executePromises(promises) {
      let numDone = 0;
      const checkAllDone = () => {
        if (numDone === promises.length) {
          return true;
        }
      }
      return new Promise((resolve, reject) => {
        this.hideAllNotifications();
        for (var i = 0; i < promises.length; i++) {
          promises[i].then((result) => {
            var scrollPlaceholder = angular.element(document.getElementById('scrollPlaceholder'));
            this.document.scrollToElement(scrollPlaceholder, 0, this.scope.scrollDuration);
            this.scope.isSubmitted = true;
            this.scope.isLoading = false;
            numDone++;
            if(checkAllDone()){
              resolve()
            }
            return;
          },
            (reason) => {
              this.scope.errorHandler = reason.data;
              var scrollPlaceholder = angular.element(document.getElementById('scrollPlaceholder'));
              this.document.scrollToElement(scrollPlaceholder, 0, this.scope.scrollDuration);
              this.scope.isLoading = false;
              numDone++;
              if(checkAllDone()){
                resolve()
              }
            });
        }
      })
    }
  }
}
